import * as React from "react";
import { useState } from "react";
import * as Mui from "@mui/material";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { minimum3Characters } from "services/constants/ErrorMessages";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { format, parse } from "date-fns";
import { leaveSuccess } from "services/constants/SuccessMessages";
import { themes } from "services/constants";
import { CustomButton } from "components/CustomComponents/CustomButton";
import sessionHandling from "services/utils/notificationUtils";
import moment from "moment";
import { formKeyText, tooltipStyleProps } from "services/constants/Styles";
import { Info } from "@mui/icons-material";

export const Leave = () => {
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [departmentDetailsApi, setDepartmentDetailsApi] = useState(true);
  const [checkboxChecked, setcheckboxChecked] = useState(false);
  const [checked, setChecked] = useState(false);
  const [firstHalfChecked, setFirstHalfChecked] = useState(false);
  const [secondHalfChecked, setSecondHalfChecked] = useState(false);
  const [approverName, setApproverName] = useState("");
  const [leaveDate, setLeaveDate] = useState([]);
  const [filteredLabel, setFilteredLabel] = useState("");
  const [filteredValue, setFilteredValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [leaveStartDate, setLeaveStartDate] = useState("");
  const [leaveEndDate, setLeaveEndDate] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [leaveTypeDetails, setLeaveTypeDetails] = useState("");

  const { register, handleSubmit, reset, setValue, trigger, watch, formState } =
    useForm({ mode: "onBlur" });
  const { errors } = formState;
  const { token, domain, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  const selectedLeave = leaveTypeOptions?.find(
    (item) => item.leave_type === watch("leave_type")
  );
  const availableLeave = selectedLeave?.available_leave ?? 0;
  const creditedLeave = selectedLeave?.credited_leave ?? 0;
  const usedLeave = selectedLeave?.used_leave ?? 0;

  useEffect(() => {
    const fetchDepartmentId = async () => {
      try {
        const response = await fetch(
          `${domain}get_leads_based_on_departments/?department_id=${userDetails.department_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setApproverName(res[0]?.department_lead_name);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    if (departmentDetailsApi) {
      fetchDepartmentId();
      setDepartmentDetailsApi(false);
    }
  }, [
    approverName,
    departmentDetailsApi,
    domain,
    setValue,
    token,
    userDetails.department_id,
  ]);

  useEffect(() => {
    const fetchLeaveTypeOptions = async () => {
      try {
        const response = await fetch(
          `${domain}leavetypefilter/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          Array.isArray(setLeaveTypeOptions(res));
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchLeaveTypeOptions();
  }, [domain, token, userDetails.id]);

  const formatDate = (dateString) => {
    const date = parse(dateString, "dd-MM-yyyy", new Date());
    const formattedDate = format(date, "yyyy-MM-dd");
    return formattedDate;
  };

  const resetForm = () => {
    reset();
    setLeaveTypeDetails("");
    setcheckboxChecked(false);
    setChecked(false);
    setFirstHalfChecked(false);
    setSecondHalfChecked(false);
    setSecondHalfChecked(false);
    const today = dayjs().format("YYYY-MM-DD");
    setStartDate(today);
    setEndDate(today);
    setValue("from_date", today);
    setValue("to_date", today);
  };

  const handleClearButtonClick = () => {
    resetForm();
  };

  const getMinDate = () => {
    const today = new Date();
    today.setDate(today.getDate());
    return today.toISOString().split("T")[0];
  };

  const onSubmit = async (data) => {
    setButtonLoader(true);
    try {
      const halfDay = firstHalfChecked || secondHalfChecked;
      const whichHalf = firstHalfChecked
        ? "1st"
        : secondHalfChecked
        ? "2nd"
        : null;
      const currentLeaveType = leaveTypeOptions?.filter((leave) => {
        return leave.leave_type === data.leave_type;
      });
      const response = await fetch(`${domain}create/leave-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          ...data,
          is_half_day: halfDay,
          half_day_period: whichHalf,
          user: userDetails.id,
          status: "Pending",
          approver: null,
          applied_date: new Date().toISOString().split("T")[0],
          createdby: userDetails.first_name,
          createdat: new Date().toISOString(),
          modifiedby: userDetails.first_name,
          modifiedat: new Date().toISOString(),
          leave_type_id: currentLeaveType[0].id,
        }),
      });
      const res = await response.json();
      if (response.ok) {
        showToast("success", leaveSuccess.leaveRequest);
        setButtonLoader(false);
        reset();
        setcheckboxChecked(false);
        setChecked(false);
        setLeaveTypeDetails("");
        setFirstHalfChecked(false);
        setSecondHalfChecked(false);
        if (
          new Date(leaveStartDate).getFullYear() === new Date().getFullYear() ||
          new Date(leaveEndDate).getFullYear() === new Date().getFullYear()
        ) {
          const today = dayjs().format("YYYY-MM-DD");
          setStartDate(today);
          setEndDate(today);
        } else {
          setStartDate(leaveStartDate);
          setEndDate(leaveEndDate);
        }
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    const fetchLeaveDate = async () => {
      try {
        const response = await fetch(`${domain}leaves-years/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const leaveDate = res.map((value) => ({
            label: value.name,
            start_date: value.start_date,
            end_date: value.end_date,
            filteredValue: `${value.start_date} - ${value.end_date}`,
          }));
          const today = dayjs().format("YYYY-MM-DD");
          const sDate = formatDate(res[0]?.start_date);
          const eDate = formatDate(res[0]?.end_date);
          setLeaveDate(leaveDate);
          setFilteredLabel(res[0]?.name);
          setFilteredValue(`${res[0]?.start_date} - ${res[0]?.end_date}`);
          setLeaveStartDate(sDate);
          setLeaveEndDate(eDate);
          if (
            new Date(
              res[0]?.start_date.split("-").reverse().join("-")
            ).getFullYear() === new Date().getFullYear() ||
            new Date(
              res[0]?.end_date.split("-").reverse().join("-")
            ).getFullYear() === new Date().getFullYear()
          ) {
            setStartDate(today);
            setEndDate(today);
          } else {
            setStartDate(sDate);
            setEndDate(eDate);
          }
          setValue("from_date", today);
          setValue("to_date", today);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchLeaveDate();
  }, [domain, setValue, token]);

  const updateLeavePeriod = (event, value) => {
    const today = dayjs().format("YYYY-MM-DD");
    if (value && value.filteredValue) {
      setFilteredLabel(value.label);
      setFilteredValue(value.filteredValue);
      setStartDate(formatDate(value.start_date));
      setEndDate(formatDate(value.end_date));
      setLeaveStartDate(formatDate(value.start_date));
      setLeaveEndDate(formatDate(value.end_date));
      if (
        new Date(
          value.start_date.split("-").reverse().join("-")
        ).getFullYear() === new Date().getFullYear() ||
        new Date(
          value.end_date.split("-").reverse().join("-")
        ).getFullYear() === new Date().getFullYear()
      ) {
        let startDateConvertions = moment(new Date()).format("DD-MM-YYYY");
        setStartDate(formatDate(startDateConvertions));
        setEndDate(formatDate(startDateConvertions));
        setValue("from_date", formatDate(startDateConvertions));
        setValue("to_date", formatDate(startDateConvertions));
      } else {
        setStartDate(formatDate(value.start_date));
        setEndDate(formatDate(value.end_date));
        setValue("from_date", formatDate(value.start_date));
        setValue("to_date", formatDate(value.end_date));
      }
    } else {
      setFilteredLabel("");
      setFilteredValue("");
      setLeaveStartDate("");
      setLeaveEndDate("");
      setFilteredLabel("");
      setFilteredValue("");
      setLeaveStartDate(today);
      setLeaveEndDate(today);
      setStartDate(today);
      setEndDate(today);
    }
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setcheckboxChecked(checked);
    const today = dayjs().format("YYYY-MM-DD");
    const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD");

    if (checked) {
      setStartDate(tomorrow);
      setEndDate(tomorrow);
      setValue("from_date", tomorrow);
      setValue("to_date", tomorrow);
      setSecondHalfChecked(false);
      setFirstHalfChecked(false);
      setChecked(false);
    } else {
      setStartDate(today);
      setEndDate(today);
      setValue("from_date", today);
      setValue("to_date", today);
      setSecondHalfChecked(false);
      setFirstHalfChecked(false);
      setChecked(false);
    }
  };

  const handleCheckboxChanged = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    if (isChecked) {
      setcheckboxChecked(false);
      setFirstHalfChecked(true);
    } else {
      setcheckboxChecked(false);
      setFirstHalfChecked(false);
    }
  };

  const handleStartDateChange = (event) => {
    const date = event.target.value;
    setStartDate(date);
    setEndDate(date);
    setValue("from_date", date);
    setValue("to_date", date);
  };

  const validateStartDate = (value) => {
    const today = dayjs().format("YYYY-MM-DD");
    if (!value) {
      return "Start date is required.";
    } else if (value < today) {
      return "Date cannot be past.";
    }
  };

  const handleEndDateChange = (event) => {
    const date = event.target.value;
    setEndDate(date);
  };

  const handleSetValue = () => {
    setValue("from_date", startDate);
    setValue("to_date", endDate);
  };

  const handleFirstHalfCheckboxChanged = (event) => {
    const checked = event.target.checked;

    if (checked) {
      setSecondHalfChecked(false);
      setcheckboxChecked(false);
      setFirstHalfChecked(checked);
    } else {
      setFirstHalfChecked(!checked);
    }
  };

  const handleSecondHalfCheckboxChanged = (event) => {
    const checked = event.target.checked;
    if (checked) {
      setFirstHalfChecked(false);
      setcheckboxChecked(false);
      setSecondHalfChecked(checked);
    } else {
      setSecondHalfChecked(!checked);
    }
  };

  const validateEndDate = (value) => {
    const today = dayjs().format("YYYY-MM-DD");
    if (!endDate) {
      return "End date is required.";
    } else if (value < today) {
      return "Date cannot be past.";
    } else if (startDate && endDate < startDate) {
      return "End date cannot be before the start date";
    }
    return true;
  };

  const updateLeaveTypeDetails = (event, data) => {
    if (data) {
      setLeaveTypeDetails(data?.label);
      setValue("leave_type", data?.label);
      setValue("leave_type_id", data?.id);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Mui.Grid container sx={{ paddingLeft: 15, paddingRight: 15, mt: 8 }}>
          <Mui.Grid container>
            <Mui.Grid
              xs={12}
              sx={{
                padding: 1,
                backgroundColor: themes.primary,
                borderRadius: "10px 10px 0 0",
                border: `2px solid ${themes.sidebarDivider}`,
                borderBottom: "none",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Mui.Typography
                sx={{ fontSize: 24, fontWeight: 800, font: "bold" }}
              >
                Apply Leave
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid
            container
            sx={{
              borderRadius: "0 0 10px 10px",
              border: `2px solid ${themes.sidebarDivider}`,
              padding: 2,
            }}
          >
            <Mui.Grid container xs={10} justifyContent={"flex-end"}>
              <Mui.Grid xs={4} sx={{ padding: 1 }}>
                <CustomAutoComplete
                  dataList={leaveDate}
                  selectedValue={filteredValue}
                  updateDataFunction={updateLeavePeriod}
                  placeHolder="Select leave period"
                  label={filteredLabel ? filteredLabel : "Leave Period"}
                />
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid container>
              <Mui.Grid item xs={4} sx={{ padding: 1 }}>
                <Mui.Typography sx={formKeyText}>
                  Leave Type&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Select the type of leave you wish to apply for from the available options."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={0.2}></Mui.Grid>
              <Mui.Grid item xs={5.8} sx={{ padding: 1 }}>
                <CustomAutoComplete
                  dataList={leaveTypeOptions?.map((obj) => ({
                    ...obj,
                    label: obj?.leave_type,
                  }))}
                  rules={{
                    ...register("leave_type", {
                      required: "Leave type is required",
                    }),
                  }}
                  selectedValue={leaveTypeDetails}
                  updateDataFunction={updateLeaveTypeDetails}
                  placeHolder="Select leave type"
                  errorMessage={
                    errors?.leave_type?.message
                      ? errors?.leave_type?.message
                      : ""
                  }
                  textBoxError={errors?.leave_type ? true : false}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container>
              <Mui.Grid item xs={4} sx={{ padding: 1 }}>
                <Mui.Typography sx={formKeyText}>
                  Credited Leaves&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Auto-displays the number of leave days credited for the selected leave type."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={0.3}></Mui.Grid>
              <Mui.Grid xs={0.6} sx={{ mt: 3 }}>
                <Mui.Typography>{creditedLeave}</Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={2.3} sx={{ mt: 1.2 }}>
                <Mui.Typography sx={formKeyText}>
                  Available Leaves&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Auto-displays the number of leave days remaining for the selected leave type."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.4} sx={{ mt: 3.2 }}>
                <Mui.Typography>{availableLeave}</Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={2} sx={{ mt: 1.3 }}>
                <Mui.Typography sx={formKeyText}>
                  Used Leaves&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Auto-displays the number of leave days used for the selected leave type."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.5} sx={{ mt: 3.2 }}>
                <Mui.Typography>{usedLeave}</Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ padding: 1, paddingLeft: 2 }}>
              <Mui.Grid item xs={4.2}></Mui.Grid>
              <Mui.Grid item xs={2.5}>
                <Mui.FormControlLabel
                  control={<Mui.Checkbox />}
                  label="Only For Tomorrow"
                  checked={checkboxChecked}
                  onChange={handleCheckboxChange}
                  onClick={handleSetValue}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontWeight: "bold",
                    },
                  }}
                />
              </Mui.Grid>
              <Mui.Grid item xs={3}>
                <Mui.FormControlLabel
                  control={
                    <Mui.Checkbox
                      checked={checked}
                      onChange={handleCheckboxChanged}
                    />
                  }
                  label="Half Day"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontWeight: "bold",
                    },
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>
            {checked && (
              <Mui.Grid container sx={{ padding: 1, paddingLeft: 2 }}>
                <Mui.Grid item xs={4.2}></Mui.Grid>
                <Mui.Grid item xs={2.5}>
                  <Mui.FormControlLabel
                    control={
                      <Mui.Checkbox
                        checked={firstHalfChecked}
                        onChange={handleFirstHalfCheckboxChanged}
                      />
                    }
                    label="1st-half"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Mui.Grid>
                <Mui.Grid item xs={3}>
                  <Mui.FormControlLabel
                    control={
                      <Mui.Checkbox
                        checked={secondHalfChecked}
                        onChange={handleSecondHalfCheckboxChanged}
                      />
                    }
                    label="2nd-half"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontWeight: "bold",
                      },
                    }}
                  />
                </Mui.Grid>
              </Mui.Grid>
            )}

            <Mui.Grid container>
              <Mui.Grid item xs={4} sx={{ padding: 1 }}>
                <Mui.Typography sx={formKeyText}>
                  Start Date&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Choose the first day of your leave period."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={0.2}></Mui.Grid>
              <Mui.Grid item xs={5.9} sx={{ padding: 1 }}>
                <Mui.TextField
                  size="small"
                  fullWidth
                  type="date"
                  id="from_date"
                  value={startDate || ""}
                  inputProps={{
                    min: getMinDate(),
                    max: leaveEndDate,
                  }}
                  {...register("from_date", {
                    required: "Start date is required.",
                    validate: validateStartDate,
                  })}
                  onChange={handleStartDateChange}
                  error={errors.from_date}
                  helperText={errors.from_date && errors.from_date.message}
                  disabled={checkboxChecked}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid container>
              <Mui.Grid item xs={4} sx={{ padding: 1 }}>
                <Mui.Typography sx={formKeyText}>
                  End Date&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Choose the last day of your leave period."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={0.2}></Mui.Grid>
              <Mui.Grid item xs={5.9} sx={{ padding: 1 }}>
                <Mui.TextField
                  size="small"
                  type="date"
                  id="to_date"
                  fullWidth
                  value={endDate}
                  inputProps={{
                    min: getMinDate(),
                    max: leaveEndDate,
                  }}
                  {...register("to_date", {
                    required: "End date is required.",
                    validate: {
                      dateNotBeforeStart: validateEndDate,
                    },
                  })}
                  onChange={handleEndDateChange}
                  error={errors.to_date}
                  helperText={errors.to_date && errors.to_date.message}
                  disabled={checked ? checked : false || checkboxChecked}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid container>
              <Mui.Grid item xs={4} sx={{ padding: 1 }}>
                <Mui.Typography sx={formKeyText}>
                  Reason for Leave&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Briefly mention the reason for your leave request."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={0.2}></Mui.Grid>
              <Mui.Grid xs={5.9} sx={{ padding: 1 }}>
                <Mui.TextField
                  fullWidth
                  id="description"
                  {...register("description", {
                    required: "Reason for leave is required",
                    validate: {
                      minLengthNoSpaces: (value) =>
                        value?.trim().length < 3 && value !== ""
                          ? minimum3Characters
                          : true,
                    },
                  })}
                  placeholder="Provide a reason for your leave"
                  multiline
                  minRows={2}
                  error={errors.description}
                  helperText={errors.description && errors.description.message}
                  onBlur={() => {
                    trigger("description");
                  }}
                />
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid container spacing={3} sx={{ paddingTop: 1 }}>
              <Mui.Grid
                item
                xs={10.2}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  padding: 1,
                }}
              >
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Resets all fields to default values."
                >
                  <CustomButton
                    actionFuntion={handleClearButtonClick}
                    actionName="Clear"
                    typeName="button"
                  />
                </Mui.Tooltip>
                &nbsp;&nbsp;
                {buttonLoader ? (
                  <CustomButton
                    disableAction={buttonLoader}
                    type="submit"
                    actionName="Apply"
                  />
                ) : (
                  <Mui.Button
                    sx={{
                      width: "100px",
                      height: "36px",

                      fontWeight: 600,
                      display: "block",
                      backgroundColor: themes.primaryButton,
                      "&:hover": {
                        backgroundColor: themes.primaryButton,
                      },
                      textTransform: "capitalize",
                      color: themes.headLine,
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Apply
                  </Mui.Button>
                )}
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </>
  );
};
